import { Button, message } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFollowAll } from '@/modules/follow/follow.hooks'
import { DepartmentWithSearch } from '@/modules/group/invite-user'

import s from './department.module.less'

interface IdsState {
  departmentIds: number[]
  userIds: number[]
}
export const DepartmentContainer = () => {
  const { t } = useTranslation()

  const [ids, setIds] = React.useState<IdsState>({
    departmentIds: [],
    userIds: [],
  })

  const followDep = useFollowAll({ followeeIds: ids.departmentIds, target: 'department' })
  const followUser = useFollowAll({ followeeIds: ids.userIds, target: 'user' })
  const key = followDep.loading || followUser.loading
  const onFollow = () => {
    followDep.followAll()
    followUser.followAll()
    setIds({
      departmentIds: [],
      userIds: [],
    })
    message.loading({ content: '正在关注中...', key })
    setTimeout(() => {
      message.success({ content: '你已成功关注这些小伙伴～', key, duration: 2 })
    }, 1000)
  }

  return (
    <div className={s.container}>
      <DepartmentWithSearch ids={ids} isPage={true} onUpdateIds={setIds} />
      <span className={s.followButton}>
        <Button type={'primary'} onClick={onFollow}>
          {t('follow.followAll')}
        </Button>
      </span>
    </div>
  )
}
